import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=593a3a98&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=593a3a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a3a98",
  null
  
)

export default component.exports